(function () {
    'use strict';

    angular
        .module('perfectStoreDashboardApp')
        .controller('MapaController', MapaController);

    MapaController.$inject = ['$http','$scope', '$compile', '$uibModal', 'showResult', '$timeout'];

    function MapaController($http,$scope, $compile, $uibModal, showResult, $timeout) {
        var vm = this;
        vm.mostrar = false;
        vm.cargando = false;
        vm.initMap = initMap;
        vm.limpiarMapa = limpiarMapa;
        vm.openModal = openModal;
        vm.openTiendasModal = openTiendasModal;
        vm.cargarMapa = cargarMapa;
        vm.mostrarModal = false;
        vm.mostrarModalTiendas = false;
        vm.rutaOperativa = '';
        vm.resultadoFiltrado = [];
        vm.abrirModalTiendas = abrirModalTiendas;

        var showResultSubscribe = showResult.subscribe(function (x) {
            console.log('[MAPA] Mensaje recibido:', x);
            if (x === "cargaMapaDatos") {
                console.log('[MAPA] Iniciando carga de mapa. Total tiendas:', vm.resultadoMapaIndicador ? vm.resultadoMapaIndicador.length : 'undefined');
                if (vm.resultadoMapaIndicador && vm.resultadoMapaIndicador.length > 0) {
                    console.log('[MAPA] Llamando a initMap() inmediatamente');
                    vm.initMap();
                }
                else {
                    console.log('[MAPA] No hay datos, esperando 2 segundos...');
                    $timeout(function () {
                        console.log('[MAPA] Después de 2 segundos. Total tiendas:', vm.resultadoMapaIndicador ? vm.resultadoMapaIndicador.length : 'undefined');
                        if (vm.resultadoMapaIndicador && vm.resultadoMapaIndicador.length > 0) {
                            console.log('[MAPA] Llamando a initMap() después del timeout');
                            vm.initMap();
                        } else {
                            console.error('[MAPA] ERROR: No hay datos después del timeout');
                        }
                    }, 2000);
                }
                vm.cargandoMapas = false;
                vm.mostrarMapas = true;
            }
        });

        vm.pos = {
            lat: 23.7248607,
            lng: -103.4066612
        };

        function openModal(objeto) {
            $uibModal.open({
                templateUrl: 'app/components/mapa/mapa.modal.html',
                controller: 'MapaModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    datosTienda: objeto
                }
            }).result.then(function (result) {
                var found = false;
                if(!vm.filtrosResultado.Distribucion){
                    vm.filtrosResultado.Distribucion = [];
                } else{
                    angular.forEach(vm.filtrosResultado.Distribucion,function(filtro){
                        if(filtro.columna == "NombreNegocio" && filtro.valor == result.filtro.nombreCompleto){
                            found = true;
                        }
                    });
                }
                if(!found){
                    vm.filtrosResultado.Distribucion.push({
                        columna: "NombreNegocio",
                        table: "Negocio",
                        tipo: "Cadena",
                        valor: result.filtro.nombreCompleto,
                        valorA: result.filtro.nombreNegocio,
                        valorMostrar: "Tiendas"
                    })
                    showResult.sendMessage(true);
                }
            });
        }

        function openTiendasModal(objeto) {
            console.log('[MAPA] openTiendasModal() llamado');
            console.log('[MAPA] Objeto recibido:', objeto);
            console.log('[MAPA] fechasElegidas:', vm.fechasElegidas);
            
            var fechaInicio = vm.fechasElegidas.FechaInicio;
            var fechaFin = vm.fechasElegidas.FechaFin;
          
            console.log('[MAPA] Abriendo modal de UI Bootstrap...');
            $uibModal.open({
              templateUrl: 'app/components/mapa/mapa.tiendas.modal.html',
              controller: 'TiendasModalController',
              controllerAs: 'vm',
              size: 'lg',
              resolve: {
                datosTienda: function() {
                  return { 
                    tiendas: objeto,
                    fechasElegidas: vm.fechasElegidas
                 };
                }
              }
            }).result.then(function(result) {
              vm.resultadoFiltrado = [];
            });
          }
          

        function cargarMapa() {
            console.log('[MAPA] cargarMapa() llamado');
            var msg = "cargarMapa";
            showResult.sendMessage(msg);
            console.log('[MAPA] Mensaje "cargarMapa" enviado a showResult');
        }

        function limpiarMapa() {
            angular.element(document.getElementById("display")).children("div").remove();
        }

        function regex(datos) {
            var myRe = new RegExp('##[0-9]*##', 'g');
            return datos.replace(myRe, '');
        }

        /* function GetIdNegocio(datos){
            var myRe = new RegExp('##[0-9]*##', 'g');
            const regex = /\d+/g;
            return datos.match(regex)[0];//devuelve un solo valor
        } */

        function GetIdNegocio(datos){
            const regex = /##(\d+)##/;
            const match = datos.match(regex);
            
            var result = match ? parseInt(match[1]) : null;
            return result;
        }

        function initMap() {
            console.log('[MAPA] initMap() iniciado');
            console.log('[MAPA] Total de tiendas a cargar:', vm.resultadoMapaIndicador.length);
            console.log('[MAPA] Primeras 3 tiendas:', vm.resultadoMapaIndicador.slice(0, 3));
            
            // Mostrar mensaje si hay muchas tiendas
            if (vm.resultadoMapaIndicador.length > 5000) {
                console.log('[MAPA] Cargando ' + vm.resultadoMapaIndicador.length + ' tiendas en el mapa. Esto puede tomar unos momentos...');
            }

            console.log('[MAPA] Creando instancia de GMaps...');
            
            // Configuración base del mapa
            var mapConfig = {
                div: "#map",
                lat: vm.pos.lat,
                lng: vm.pos.lng
            };
            
            // Verificar si MarkerClusterer está disponible
            if (typeof MarkerClusterer !== 'undefined') {
                console.log('[MAPA] MarkerClusterer disponible - habilitando clustering');
                mapConfig.markerClusterer = function (map) {
                    var markerClusterer = new MarkerClusterer(map, [], { 
                        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                        minimumClusterSize: 10,
                        maxZoom: 15,
                        gridSize: 60,
                        averageCenter: true
                    });
                
                        // Agrega un escucha de eventos que se activará cuando se haga clic en un cluster
                        google.maps.event.addListener(markerClusterer, 'clusterclick', function(cluster) {
                            console.log('[MAPA] Click en cluster detectado');
                            
                            var markers = cluster.getMarkers();
                            console.log('[MAPA] Marcadores en el cluster:', markers.length);
                            
                            // Obtener el zoom máximo del mapa
                            var maxZoom = map.maxZoom;
                            // Obtener el zoom actual del mapa
                            var currentZoom = map.getZoom();
                            console.log('[MAPA] Zoom actual:', currentZoom, '/ Zoom máximo:', maxZoom);

                            var idNegociosGrupo = markers.map(function(objeto) {
                                return Number(GetIdNegocio(objeto.title)) 
                            });
                            console.log('[MAPA] IDs de negocios en el cluster:', idNegociosGrupo);

                            //obtengo los negocios del grupo
                            console.log('[MAPA] Filtrando tiendas del cluster...');
                            vm.resultadoFiltrado = vm.resultadoMapaIndicador.filter(function(indicador) {
                                return idNegociosGrupo.some(function(idNegocio) {
                                  return idNegocio === indicador.idNegocio;
                                });
                              }).map(function(indicador) {
                                return {
                                  idNegocio: indicador.idNegocio,
                                  negocio: regex(indicador.nombreNegocio),
                                  latitud: indicador.latitud,
                                  longitud: indicador.longitud,
                                  pathImage: "",
                                  direccionGoogle: ""
                                };
                              });  

                           
                            

                             console.log('[MAPA] Tiendas filtradas:', vm.resultadoFiltrado.length);
                             
                             //ordernar por latitud y longitud
                              vm.resultadoFiltrado.sort(function(a, b) {
                                if (a.latitud < b.latitud) {
                                  return -1;
                                } else if (a.latitud > b.latitud) {
                                  return 1;
                                } else {
                                  if (a.longitud < b.longitud) {
                                    return -1;
                                  } else if (a.longitud > b.longitud) {
                                    return 1;
                                  } else {
                                    return 0;
                                  }
                                }
                              });
                              
                            console.log('[MAPA] Tiendas ordenadas');

                            if(currentZoom >= 20){
                                  console.log('[MAPA] Zoom >= 20, abriendo modal de tiendas');
                                  abrirModalTiendas();
                            } else {
                                  console.log('[MAPA] Zoom < 20, no se abre modal automáticamente');
                            }
                            
                        });

                        // Agrega un escucha de eventos para capturar el clic derecho en un cluster
                        google.maps.event.addListener(markerClusterer, 'rightclick', function (cluster) {
                            console.log('Se hizo clic derecho en un cluster');
                            // Realiza las acciones que deseas realizar al capturar el evento de clic derecho en un cluster
                        });   

                        return markerClusterer;
                    };
            } else {
                console.warn('[MAPA] MarkerClusterer NO disponible - el mapa funcionará sin clustering');
                console.warn('[MAPA] Esto puede afectar el rendimiento con muchas tiendas');
            }
            
            vm.map = new GMaps(mapConfig);

            vm.styles = [{
                "featureType": "landscape", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 65 }

                    ,

                    { "visibility": "on" }

                ]
            }, {
                "featureType": "poi", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 51 }

                    ,

                    { "visibility": "simplified" }

                ]
            }, {
                "featureType": "road.highway", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "visibility": "simplified" }

                ]
            }, {
                "featureType": "road.arterial", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 30 }

                    ,

                    { "visibility": "on" }

                ]
            }, {
                "featureType": "road.local", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "lightness": 40 }

                    ,

                    { "visibility": "on" }

                ]
            }, {
                "featureType": "transit", "stylers": [

                    { "saturation": -100 }

                    ,

                    { "visibility": "simplified" }

                ]
            }, {
                "featureType": "administrative.province", "stylers": [

                    { "visibility": "off" }

                ]
            }, {
                "featureType": "water", "elementType": "labels", "stylers": [

                    { "visibility": "on" }

                    ,

                    { "lightness": -25 }

                    ,

                    { "saturation": -100 }

                ]
            }, {
                "featureType": "water", "elementType": "geometry", "stylers": [

                    { "hue": "#ffff00" }

                    ,

                    { "lightness": -25 }

                    ,

                    { "saturation": -97 }

                ]
            }];

            vm.map.addStyle({
                styledMapName: "Styled Map",
                styles: vm.styles,
                mapTypeId: "map_style"
            });

            vm.map.setStyle("map_style");

            var bounds = new google.maps.LatLngBounds();
            
            // Procesar marcadores en lotes para mejorar rendimiento con datasets grandes
            var batchSize = 500;
            var totalMarkers = vm.resultadoMapaIndicador.length;
            var currentBatch = 0;
            
            function processBatch() {
                var start = currentBatch * batchSize;
                var end = Math.min(start + batchSize, totalMarkers);
                
                console.log('[MAPA] Procesando lote', currentBatch + 1, '- Tiendas', start, 'a', end, 'de', totalMarkers);
                
                var marcadoresInvalidos = 0;
                for (var i = start; i < end; i++) {
                    var marcador = vm.resultadoMapaIndicador[i];
                    
                    // Validar que tenga coordenadas válidas
                    if (!marcador.latitud || !marcador.longitud || 
                        isNaN(parseFloat(marcador.latitud)) || isNaN(parseFloat(marcador.longitud))) {
                        marcadoresInvalidos++;
                        continue;
                    }
                    
                    var pt = new google.maps.LatLng(parseFloat(marcador.latitud), parseFloat(marcador.longitud));
                    bounds.extend(pt);
                    
                    var nombre = marcador.nombreNegocio;
                    var icon;
                    
                    if (marcador.objetivo === 0) {
                        icon = 'content/images/pinMapaAzul.png'
                    }
                    else if(marcador.resultado >= marcador.objetivo){
                        icon = 'content/images/pinMapaVerde.png'
                    }
                    else if(marcador.resultado < marcador.objetivo){
                        icon = 'content/images/pinMapaNaranja.png'
                    }
                    
                    // Usar closure para capturar el marcador correcto
                    (function(currentMarcador, currentNombre) {
                        vm.map.addMarker({
                            lat: parseFloat(currentMarcador.latitud),
                            lng: parseFloat(currentMarcador.longitud),
                            title: currentNombre,
                            icon: icon,
                            click: function (e) {
                                vm.cargando = true;
                                vm.idNegocio = currentMarcador.idNegocio;
                                vm.nombreNegocio = currentNombre;
                                vm.nombreCadena = regex(currentMarcador.nombreCadena);
                                vm.formato = regex(currentMarcador.formato);
                                vm.direccion = currentMarcador.direccion;
                                vm.latitud = currentMarcador.latitud;
                                vm.longitud = currentMarcador.longitud;
                                vm.mostrarModal = true;
                                //obtener rutaoperativa 
                                $http.get('api/mapa/rutaoperativa/' + vm.idNegocio).then(function(response) {
                                    vm.rutaOperativa = response.data;
                                    var objeto = {
                                        nombreCompleto: currentMarcador.nombreNegocio,
                                        idNegocio: vm.idNegocio, 
                                        nombreNegocio: vm.nombreNegocio, 
                                        nombreCadena: vm.nombreCadena,
                                        formato: vm.formato, 
                                        direccion: vm.direccion, 
                                        latitud: vm.latitud, 
                                        longitud: vm.longitud,
                                        rutaOperativa: vm.rutaOperativa
                                    };
                                    vm.cargando = false;
                                    vm.openModal(objeto);
                                });
                            }
                        });
                    })(marcador, nombre);
                }
                
                if (marcadoresInvalidos > 0) {
                    console.warn('[MAPA] Marcadores inválidos en este lote:', marcadoresInvalidos);
                }
                
                currentBatch++;
                
                // Si hay más lotes, procesarlos con un pequeño delay
                if (end < totalMarkers) {
                    $timeout(function() {
                        processBatch();
                    }, 10);
                } else {
                    // Cuando termine, ajustar bounds
                    console.log('[MAPA] Todos los lotes procesados. Ajustando bounds...');
                    vm.map.fitLatLngBounds(bounds);
                    vm.map.fitBounds(bounds);
                    console.log('[MAPA] ✓ Mapa cargado exitosamente con', totalMarkers, 'tiendas');
                    console.log('[MAPA] Total de marcadores en el mapa:', vm.map.markers ? vm.map.markers.length : 'undefined');
                }
            }
            
            // Iniciar procesamiento por lotes
            processBatch();
        }

        function abrirModalTiendas(){
            console.log('[MAPA] abrirModalTiendas() llamado');
            console.log('[MAPA] resultadoFiltrado:', vm.resultadoFiltrado);
            console.log('[MAPA] Total tiendas filtradas:', vm.resultadoFiltrado ? vm.resultadoFiltrado.length : 0);
            
            if (!vm.resultadoFiltrado || vm.resultadoFiltrado.length === 0) {
                console.warn('[MAPA] WARNING: No hay tiendas filtradas para mostrar');
                console.log('[MAPA] Total de tiendas en mapa:', vm.resultadoMapaIndicador ? vm.resultadoMapaIndicador.length : 0);
                
                // Si no hay filtrado, mostrar todas las tiendas
                if (vm.resultadoMapaIndicador && vm.resultadoMapaIndicador.length > 0) {
                    console.log('[MAPA] Usando todas las tiendas del mapa');
                    vm.resultadoFiltrado = vm.resultadoMapaIndicador.map(function(indicador) {
                        return {
                            idNegocio: indicador.idNegocio,
                            negocio: regex(indicador.nombreNegocio),
                            latitud: indicador.latitud,
                            longitud: indicador.longitud,
                            pathImage: "",
                            direccionGoogle: ""
                        };
                    });
                    console.log('[MAPA] resultadoFiltrado actualizado con', vm.resultadoFiltrado.length, 'tiendas');
                }
            }
            
            vm.mostrarModalTiendas = true;
            console.log('[MAPA] Abriendo modal con', vm.resultadoFiltrado.length, 'tiendas');
            vm.openTiendasModal(vm.resultadoFiltrado);
        }
    }
})();
